export function getRandomId() {
  return String(Math.floor(Math.random() * 4294967295) + 1);
}
